<template>
  <div style="display: table;height:100%;width:100%">
    <div class="g-center">
      <h1 style="text-align:center">401</h1>
    </div>
  </div>
</template>

<script>
	export default {
		name: "err401"
	}
</script>

<style scoped>
  .g-center{
    display: table-cell;

    vertical-align: middle;
  }
</style>